import { download } from '@invivodf/common/src/infrastructure/download.service'
import { MetaDiscountDiscountablesProvided, useMetaDiscount } from './useMetaDiscount'
import { useLoadedForm } from '../useLoadedForm'
import { downloadMetaDiscountAssociations } from '../../../dependency-injection'
import { FormModes } from '../../../domain/constants/FormModes'

export interface IUseMetaDiscountDiscountables {
  discountables: MetaDiscountDiscountablesProvided
  downloadDiscountables: () => Promise<void>
  setDiscountablesCount: (count: number) => void
  setDiscountablesFile: (file: File) => void
  setIsExcludedAssociations: (isExcluded: boolean) => void
  isFormUpdate: () => boolean
  isExcludedAssociationsForm: () => boolean
}

export enum DiscountablesMode {
  INCLUDED = 'is_included_associations',
  EXCLUDED = 'is_excluded_associations',
}

export const useMetaDiscountDiscountables = (): IUseMetaDiscountDiscountables => {
  const { discountables } = useMetaDiscount()
  const form = useLoadedForm()

  const downloadDiscountables = async () => {
    if (discountables.file.value) download(discountables.file.value, 'discount_associations.csv')
    else await downloadMetaDiscountAssociations.execute(form.value.reference.validatedValue, form.value.participants)
  }

  const setDiscountablesCount = (count: number) => {
    discountables.count.value = count
  }

  const setDiscountablesFile = (file: File) => {
    discountables.file.value = file
  }

  const setIsExcludedAssociations = (isExcluded: boolean) => {
    form.value.setIsExcludedAssociations(isExcluded)
  }

  const isFormUpdate = () => {
    return form.value.mode === FormModes.UPDATE
  }

  const isExcludedAssociationsForm = () => {
    return form.value.isExcludedAssociations
  }

  return {
    discountables,
    downloadDiscountables,
    setDiscountablesCount,
    setDiscountablesFile,
    setIsExcludedAssociations,
    isFormUpdate,
    isExcludedAssociationsForm,
  }
}
